import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import installElementPlus from './plugins/element'
import './assets/css/icon.css'
import vue3JsonExcel from "vue3-json-excel"

const app = createApp(App)
installElementPlus(app)
app.use(store)
app.use(router)
app.use(vue3JsonExcel)
app.mount('#app')
